"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.Session = void 0;
var web3_js_1 = require("@solana/web3.js");
var Session = /** @class */ (function () {
    function Session(sdk) {
        this.sdk = sdk;
    }
    Session.prototype.get = function (sessionAccount) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sdk.session_program.account.sessionToken.fetch(sessionAccount)];
            });
        });
    };
    Session.prototype.create = function (targetProgram, owner, topUp, validUntil) {
        if (topUp === void 0) { topUp = false; }
        if (validUntil === void 0) { validUntil = null; }
        return __awaiter(this, void 0, void 0, function () {
            var sessionSigner, instructionMethodBuilder, pubKeys, sessionPDA;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionSigner = web3_js_1.Keypair.generate();
                        instructionMethodBuilder = this.sdk.session_program.methods.createSession(topUp, validUntil)
                            .accounts({
                            targetProgram: targetProgram,
                            sessionSigner: sessionSigner.publicKey,
                            authority: owner
                        });
                        return [4 /*yield*/, instructionMethodBuilder.pubkeys()];
                    case 1:
                        pubKeys = _a.sent();
                        sessionPDA = pubKeys.sessionToken;
                        return [2 /*return*/, {
                                instructionMethodBuilder: instructionMethodBuilder,
                                sessionSigner: sessionSigner,
                                sessionPDA: sessionPDA
                            }];
                }
            });
        });
    };
    Session.prototype.revoke = function (sessionAccount, owner) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.sdk.session_program.methods.revokeSession()
                        .accounts({
                        sessionToken: sessionAccount,
                        authority: owner
                    })];
            });
        });
    };
    return Session;
}());
exports.Session = Session;
